import { http } from 'vue'

export default {
  loadSubcategories (context, params) {
    return http.get('subcategories?category_id=' + params.categoryId + '&with=counter&sort=name')
  },
  // load client from the API server
  loadSubcategory (context, params = {}) {
    let withParam = params.with ? '?with=' + params.with : ''
    return http.get('subcategories/' + params.id + withParam)
  },
  saveSubcategories (context, payload) {
    context.commit('SAVE_SUBCATEGORIES', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/subcategories/actions.js